export const RewardLinkType = Object.freeze({
  REWARD_LINK: 'REWARD_LINK',
  PROMO_LINK: 'PROMO_LINK',
  DISBURSEMENT_LINK: 'DISBURSEMENT_LINK'
})

export const RewardLinkAttributes = Object.freeze({
  IS_REDEEMABLE_FOR_CASH_ITEMS: 'IS_REDEEMABLE_FOR_CASH_ITEMS'
})
